import * as React from 'react'
import './styles.scss'

const EmailIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="10 15 35 15" fill="#004992">
      <g transform="translate(-1603 -7423)">
        <rect className="a" width="50" height="40" transform="translate(1603 7423)"/>
        <path d="M25.5,6H5.5A2.5,2.5,0,0,0,3.012,8.5L3,23.5A2.507,2.507,0,0,0,5.5,26h20A2.507,2.507,0,0,0,28,23.5V8.5A2.507,2.507,0,0,0,25.5,6Zm0,5-10,6.25L5.5,11V8.5l10,6.25,10-6.25Z" transform="translate(1612.5 7427)"
        />
      </g>
    </svg>
  )
}

export default EmailIcon
